
export const isNotNull = (value: string | number | null | undefined) => {
  return Number(value) || 0;
};




